import { render, staticRenderFns } from "./Detailspage.vue?vue&type=template&id=58c643fa&scoped=true"
import script from "./Detailspage.vue?vue&type=script&lang=js"
export * from "./Detailspage.vue?vue&type=script&lang=js"
import style0 from "./Detailspage.vue?vue&type=style&index=0&id=58c643fa&prod&scoped=true&lang=css"
import style1 from "./Detailspage.vue?vue&type=style&index=1&id=58c643fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c643fa",
  null
  
)

export default component.exports